import React from "react";
import SEO from "../shared/SEO";
import pattern from '../../assets/pattern.png'
import Navbar from "./Navbar";
import Footer from "./Footer";
import ellipse1 from '../../assets/Ellipse 4.png'
import unique from '../../assets/unique.png'
import uniquelong from '../../assets/uniquelong.png'
import { useNavigate } from "react-router-dom";
import group19 from '../../assets/Group 19.png'

const AboutUs = () => {
  const navigate = useNavigate();
  return (
    <div className="bg-white">
      <SEO
        title="About Orcas Valley | A Founder-First Startup Platform"
        description="Orcas Valley empowers founders with tools, guidance, and funding access without equity loss or traditional accelerator pressure."
        url="https://orcasvalley.web.app/about"
        keywords="about orcas valley, startup platform, founder support, startup accelerator alternative, entrepreneur tools"
      />
           <Navbar />
      {/* Hero Section */}
      <header className="relative text-white h-[85vh] flex items-center px-6 sm:px-10 ">
  {/* Background Image */}
  <div className="absolute inset-0 px-6 md:px-10 py-2 md:py-0">
    <div 
      className="w-full h-full bg-cover bg-center rounded-xl"
      style={{ backgroundImage: "url('/AboutUs.png')" }}
    ></div>
  </div>

  {/* Content Container */}
  <div className="relative px-4 sm:px-20 mt-32 sm:mt-44 text-center sm:text-left">
    <h1 className="text-4xl sm:text-6xl font-medium leading-tight">
      Startup Success, <br /> Reimagined
    </h1>
    <p className="mt-4 text-base sm:text-lg font-light max-w-lg mx-auto sm:mx-0">
      The Orcas Valley challenges the status quo, offering founders a smoother path to success, without the pitfalls of equity loss or traditional accelerator roadblocks.
    </p>

    {/* Buttons */}
    <div className="mt-6 flex flex-col sm:flex-row items-center space-y-3 sm:space-y-0 sm:space-x-3">
      {/* Console.log("Console.log("Console.log("");");");Now Button */}
      <button
        onClick={() => navigate('/auth')} 
      className="px-6 py-2 bg-white text-black hover:bg-[#2CFFCC] rounded-full font-light flex items-center space-x-2 shadow-md">
        <span>Apply Now</span> 
        <span className="text-lg">→</span>
      </button>

      {/* Separator (Hidden on Mobile) */}
      <span className="hidden sm:block text-gray-400 text-lg">•</span>

      {/* Become an Orca Button */}
      <button className="text-gray-300 font-light">Become an Orca</button>
    </div>
  </div>

  {/* Vertical Text - Positioned at Top Left */}
  <div className="absolute top-6 left-2 xs:left-2 sm:top-10 sm:left-6 md:left-10 z-20 px-5 flex flex-col items-center text-gray-300 text-lg tracking-widest  sm:flex">
    <div className="border-l-2 border-gray-300 h-8 sm:h-10 mb-2"></div>
    <p className="flex flex-col text-center text-xs">
      <span>T</span>
      <span>H</span>
      <span>E</span>
      <br />
      <span>O</span>
      <span>R</span>
      <span>C</span>
      <span>A</span>
      <span>S</span>
      <br />
      <span>W</span>
      <span>A</span>
      <span>Y</span>
    </p>
  </div>
</header>





  {/* What is Orcas Valley? */}
<section className="relative w-full md:h-[] py-16 px-4 sm:px-4 bg-white">
  {/* Background Image or Ellipse */}
  <div className="absolute inset-0 z-0 opacity-30 pointer-events-none">
    <img
      src={ellipse1}
      alt="Background"
      className="w-full h-full object-cover"
    />
  </div>
  <div className="absolute right-0 bottom-0 top-36 h-[70%] w-[40%] z-0 pointer-events-none">
    <img
      src={group19}
      alt="Background right image"
      className="w-full h-full object-cover object-right"
    />
  </div>
  
  {/* Content */}
  <div className="relative z-10 w-full max-w-[90%] md:max-w-[90%] lg:max-w-[85%] xl:max-w-[85%] mx-auto text-left">
    <h2 className="text-2xl sm:text-3xl md:text-4xl font-light text-gray-700 mb-6">
      What is <span className="text-[#02C4A1] font-medium">Orcas Valley?</span>
    </h2>

    <p className="text-gray-800 text-base sm:text-lg leading-relaxed mb-4">
      The Orcas Valley was founded to empower entrepreneurs by addressing the challenges of  traditional venture models, which often prioritize profit over innovation, leading to stress and failure.
    </p>

    <p className="text-gray-800 text-base sm:text-lg leading-relaxed mb-4">
      Born from personal and professional adversity, our journey provided deep insights into startup struggles—lack of resources, relentless pressure, and systemic roadblocks. We set out to change that.
    </p>

    <p className="text-gray-800 text-base sm:text-lg leading-relaxed">
      Our mission is to equip founders with the tools to succeed on their own terms, fostering a supportive ecosystem where learning, building, and scaling happen seamlessly. Every entrepreneur deserves the chance to thrive, and we’re committed to making that a reality.
    </p>
  </div>
</section>




{/* Unique Section */}
<section className="relative text-white h-auto md:h-[60vh] lg:h-[85vh] w-full hidden md:flex md:flex-row items-center justify-end py-12 px-6 sm:px-10 md:px-2 bg-no-repeat bg-cover bg-center"
style={{ backgroundImage: `url(${unique})` }} 
>
  {/* Background Image */}
  {/* <img 
    src={unique} 
    alt="Unique Section Background" 
    className="absolute inset-0 w-full h-full object-cover rounded-lg"
  /> */}

  {/* Content Overlay (Positioned Right) */}
  <div className="relative z-10 max-w-lg  text-right sm:text-left md:text-left px-4  sm:pr-5 md:pr-10 lg:mr-10 md:mr-2  ">
    <h2 className="text-3xl sm:text-3xl font-light">
      What Makes Us<br/> <span className="text-[#02C4A1]">Unique?</span>
    </h2>
    {/* <p className="text-base sm:text-lg mt-4 leading-relaxed text-white pr-4" style={{ opacity: 0.84 }}>
      The Orcas Valley is not just an accelerator—it’s a new current. We’re an alternative to 
      traditional venture capitalist models, rejecting the equity-heavy approaches that often 
      leave founders at a disadvantage. Our comprehensive platform provides startup 
      resources—from The Orca Blueprint eBook and AI-powered pitch deck generator to access 
      to investors—all designed to help founders learn, pitch, and secure funding without losing 
      control of their vision or jeopardizing it.Traditional accelerators are intimidating, equity-intensive, and often out of reach.
      We built Orcas Valley to remove those barriers—no equity, no unnecessary stress, just practical support
    </p> */}
    <p className="text-base sm:text-lg mt-4 leading-relaxed mr-2 sm:mr-0 md:mr-2" style={{ opacity: 0.9 }}>
      The Orcas Valley is not just an accelerator; it’s a new current. We’re an alternative to traditional venture capitalist models, rejecting the equity-heavy approaches that often leave founders at a disadvantage.
    </p>

    <p className="text-base sm:text-lg  leading-relaxed mr-2" style={{ opacity: 0.9 }}>
      Our comprehensive platform provides startup resources from The Orca Blueprint eBook and AI-powered pitch deck generator to access to investors, all designed to help founders learn, pitch, and secure funding without losing control of their vision.
    </p>

    <p className="text-base sm:text-lg  leading-relaxed mr-2" style={{ opacity: 0.9 }}>
      Traditional accelerators are intimidating, equity-intensive, and often out of reach. We built Orcas Valley to remove those barriers: no equity, no unnecessary stress, just practical support.
    </p>
  </div>
</section>

<section className="relative text-white  h-[120vh] sm:h-[120vh] w-full flex flex-col items-center justify-end py-12 px-6 sm:px-5 bg-no-repeat bg-cover bg-end  md:hidden "
style={{ backgroundImage: `url(${uniquelong})` }} 
>
  {/* Background Image */}
  {/* <img 
    src={unique} 
    alt="Unique Section Background" 
    className="absolute inset-0 w-full h-full object-cover rounded-lg"
  /> */}

  {/* Content Overlay (Positioned Right) */}
  <div className="relative z-10 max-w-lg  text-left sm:text-left md:text-left px-4  sm:pr-5 md:pr-10 lg:mr-10 md:mr-2 ">
    <h2 className="text-3xl sm:text-3xl font-light">
      What Makes Us<br/> <span className="text-[#02C4A1]">Unique?</span>
    </h2>
    {/* <p className="text-base sm:text-lg mt-4 leading-relaxed text-white pr-4" style={{ opacity: 0.84 }}>
      The Orcas Valley is not just an accelerator—it’s a new current. We’re an alternative to 
      traditional venture capitalist models, rejecting the equity-heavy approaches that often 
      leave founders at a disadvantage. Our comprehensive platform provides startup 
      resources—from The Orca Blueprint eBook and AI-powered pitch deck generator to access 
      to investors—all designed to help founders learn, pitch, and secure funding without losing 
      control of their vision or jeopardizing it.Traditional accelerators are intimidating, equity-intensive, and often out of reach.
      We built Orcas Valley to remove those barriers—no equity, no unnecessary stress, just practical support
    </p> */}
    <p className="text-base sm:text-lg mt-4 leading-relaxed mr-2 sm:mr-0 md:mr-2" style={{ opacity: 0.9 }}>
      The Orcas Valley is not just an accelerator; it’s a new current. We’re an alternative to traditional venture capitalist models, rejecting the equity-heavy approaches that often leave founders at a disadvantage.
    </p>

    <p className="text-base sm:text-lg  leading-relaxed mr-2" style={{ opacity: 0.9 }}>
      Our comprehensive platform provides startup resources from The Orca Blueprint eBook and AI-powered pitch deck generator to access to investors, all designed to help founders learn, pitch, and secure funding without losing control of their vision.
    </p>

    <p className="text-base sm:text-lg  leading-relaxed mr-2" style={{ opacity: 0.9 }}>
      Traditional accelerators are intimidating, equity-intensive, and often out of reach. We built Orcas Valley to remove those barriers: no equity, no unnecessary stress, just practical support.
    </p>
  </div>
</section>









{/* Meet the Team Section */}
<section className="relative bg-[#F5FDFC] py-16 px-6 flex flex-col items-center">

  {/* Left & Right Backgrounds (Only Visible on Desktop) */}
  <div
    className="absolute top-0 left-0 w-1/3 h-full hidden lg:block"
    style={{ backgroundImage: "url('/path-to-left-bg.png')", backgroundSize: "cover", backgroundPosition: "left" }}
  ></div>
  
  <div
    className="absolute top-0 right-0 w-1/3 h-full hidden lg:block"
    style={{ backgroundImage: "url('/path-to-right-bg.png')", backgroundSize: "cover", backgroundPosition: "right" }}
  ></div>

  {/* Heading */}
  <div className="text-center max-w-3xl mb-10 relative z-10">
    <h2 className="text-gray-800 text-3xl sm:text-4xl font-extralight">
      Meet The <span className="text-[#02C4A1]">Team</span>
    </h2>
    <p className="text-gray-500 mt-3 text-sm sm:text-base">
      The Orcas Valley is led by experienced entrepreneurs, technologists, and investors driven by a shared passion
      for helping startups succeed and turning challenges into growth opportunities.
    </p>
  </div>

  {/* Responsive Layout: 1-column for mobile, 4-column for desktop */}
  <div className="grid grid-cols-1 lg:grid-cols-4 gap-6 w-full max-w-5xl mx-auto items-center relative z-10">

    {/* Column 1 */}
    <div className="flex flex-col gap-4">
      <img src="imageA.png" className="rounded-xl w-full" alt="Team Member A" />
      <img src="imageB.png" className="rounded-xl w-full" alt="Team Member B" />
      <div className="bg-[#C1F7E1] p-4 sm:p-6 rounded-xl text-sm sm:text-lg text-[#034237] font-light">
        The Orcas Valley is your partner in success, guiding you while safeguarding your vision.
      </div>
    </div>

    {/* Column 2 */}
    <div className="flex flex-col gap-4">
      <img src="imageC.png" className="rounded-xl w-full" alt="Team Member C" />
      <img src="imageD.png" className="rounded-xl w-full" alt="Team Member D" />
    </div>

    {/* Column 3 */}
    <div className="flex flex-col gap-4">
      <div className="bg-[#D2FAE9] p-4 sm:p-6 rounded-xl text-sm sm:text-lg font-light text-gray-800">
        Innovation drives us. By listening to our community and leveraging technology, we create cutting-edge tools
        like our AI-powered pitch deck generator and personalized feedback loops.
      </div>
      <img src="imageE.png" className="rounded-xl w-full" alt="Team Member E" />
      <img src="ImageF (1).jpg" className="rounded-xl w-full" alt="Team Member F" />
    </div>

    {/* Column 4 */}
    <div className="flex flex-col gap-4">
      <img src="imageG.png" className="rounded-xl w-full" alt="Team Member G" />
      <img src="imageH.png" className="rounded-xl w-full" alt="Team Member H" />
      <div className="bg-[#C1F7E1] p-4 sm:p-6 rounded-xl text-sm sm:text-lg text-gray-800">
        At The Orcas Valley, your success is our priority. We provide tailored resources, hands-on support, and a strong foundation.
      </div>
    </div>
  </div>
</section>







    <Footer />
    </div>
  );
};

export default AboutUs;
